import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import Header from '../components/utils/Header';
import User from '../api/User';
import { getBackendUrl, saveToken } from '../utils';
import { reloadCurrentUser } from '../store/currentUser';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';


const styles = theme => ({
  container: {
    maxWidth: theme.spacing(75),
  },
  warnIcon: {
     color: '#ffa600',
  },
  ssoH3:{
    display: 'inline-flex',
    verticalAlign: 'middle',
    alignItems: 'center'
  }
});


@withStyles(styles)
@observer
class LoginView extends React.Component {
  @observable email = '';
  @observable password = '';

  onChangeEmail = event => {
    this.email = event.target.value;
  };

  onChangePassword = event => {
    this.password = event.target.value;
  };

  onSubmit = async event => {
    event.preventDefault();
    const token = (await User.ajaxRequest(
      'post', '/login/',
      { data: { username: this.email, password: this.password } },
    )).data.token;
    saveToken(token);
    await reloadCurrentUser();
  };

  render() {
    const { classes } = this.props;
    return (
      <form onSubmit={this.onSubmit}>
        <Grid container direction="column" spacing={8} className={classes.container}>
          <Grid item>
            <Header title="Login" />
          </Grid>
          <Grid item container direction="column" spacing={2}>
          <Grid item>
            <h3 className={classes.ssoH3}>
              <ErrorOutlineIcon className={classes.warnIcon}></ErrorOutlineIcon>
              &nbsp;<span> Use primarily if Danone Employee </span>
            </h3>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              size="large"
              component="a"
              href={getBackendUrl('/saml2_auth/login')}
              fullWidth
            >
              Log using your Danone account
            </Button>
          </Grid>
          </Grid>
          <Grid item container direction="column" spacing={2}>
            <Grid item>
              <h4>Or log using a special account existing only in this application:</h4>
            </Grid>
            <Grid item>
              <TextField
                type="email"
                label="E-mail"
                value={this.email}
                onChange={this.onChangeEmail}
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid item>
              <TextField
                type="password"
                label="Password"
                value={this.password}
                onChange={this.onChangePassword}
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid item>
              <Button type="submit" variant="contained" fullWidth>
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    );
  }
}


export default LoginView;
